export default {
    CLICK: 0,
    SALE: 5,
    LEAD: 1,
    TRIAL: 3,
}